import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationGrundfosAdobeItemData, IntegrationGrundfosData } from './Data';

interface AdobeItemState {
  companyCode: string;
  language: string;
  pageName: string;
  rsid: string;
  siteCountry: string;
}

export interface IntegrationGrundfosState extends BaseIntegrationState {
  tracking?: {
    adobe?: AdobeItemState;
  };
}

export class IntegrationGrundfosModel extends BaseIntegration<IntegrationGrundfosData, IntegrationGrundfosState> {
  parse(data: IntegrationGrundfosData) {
    super.parse(data);

    this.state.tracking = this.state.tracking || {};

    if (data.settings?.tracking?.adobe) {
      this.state.tracking.adobe = this.constructsAdobeState(data.settings.tracking.adobe, this.state.tracking.adobe);
    } else {
      this.state.tracking = undefined;
    }
  }

  constructsAdobeState(data: IntegrationGrundfosAdobeItemData, adobeState?: AdobeItemState): AdobeItemState {
    if (adobeState) {
      adobeState.companyCode = data.company_code;
      adobeState.language = data.language;
      adobeState.pageName = data.page_name;
      adobeState.rsid = data.rsid;
      adobeState.siteCountry = data.site_country;

      return adobeState;
    } else {
      return {
        companyCode: data.company_code,
        language: data.language,
        pageName: data.page_name,
        rsid: data.rsid,
        siteCountry: data.site_country
      };
    }
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
